import { render } from "./SVGResizeV.vue?vue&type=template&id=c8711ee2"
import script from "./SVGResizeV.vue?vue&type=script&lang=js"
export * from "./SVGResizeV.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__